/**
 * Default configuration values for the OTP Input component.
 */
const OTP_INPUT_DEFAULTS = {
  /** Default number of digits in the OTP input. */
  LENGTH: 6,
} as const

export { OTP_INPUT_DEFAULTS as otpInputDefaults }
